import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { ProductsService } from "../services/products.service";

export const ProductResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(ProductsService).fetchOneProduct(
    route.paramMap.get("id")
  );
};
